import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=f00ab1e4&scoped=true"
import script from "./Spinner.vue?vue&type=script&lang=ts"
export * from "./Spinner.vue?vue&type=script&lang=ts"
import style0 from "./Spinner.vue?vue&type=style&index=0&id=f00ab1e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00ab1e4",
  null
  
)

export default component.exports